module.exports = __webpack_public_path__ + "static/skims-fff786e52a8cb379521d204470337773.jpg";